'use client';

import { c as _c } from "react/compiler-runtime";
import { copyToClipboard } from '@shared/utils/helpers/clipboard';
import toast from '@shared/utils/helpers/toast';
import { Clipboard } from 'lucide-react';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import Input from '../UI/Input';
type Props = {
  closeHandler: () => void;
  postId: string;
};
const EmbedPostModal = t0 => {
  const $ = _c(16);
  const {
    closeHandler,
    postId
  } = t0;
  const iframeValue = `<iframe src="${process.env.NEXT_PUBLIC_SITE_URL}/post/${postId}?embed=true" frameborder="0" style="width: 100%; max-width: 500px; height: 100%; border-radius: 10px; min-height: 300px;"></iframe>`;
  let t1;
  if ($[0] !== iframeValue) {
    t1 = async () => {
      await copyToClipboard(iframeValue);
      toast("Embed code copied to clipboard");
    };
    $[0] = iframeValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copyLinkToClipboard = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2>Embed post</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeHandler) {
    t3 = <ModalHeader closeHandler={closeHandler}>{t2}</ModalHeader>;
    $[3] = closeHandler;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-start">Paste the below code in any HTML page to embed the selected post:</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== iframeValue) {
    t5 = <Input type="textarea" value={iframeValue} disabled={true} />;
    $[6] = iframeValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute bottom-2 right-2"><Clipboard /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== copyLinkToClipboard || $[10] !== t5) {
    t7 = <ModalContent>{t4}<div><div className="relative" onClick={copyLinkToClipboard}>{t5}{t6}</div></div></ModalContent>;
    $[9] = copyLinkToClipboard;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== closeHandler || $[13] !== t3 || $[14] !== t7) {
    t8 = <Modal closeHandler={closeHandler}>{t3}{t7}</Modal>;
    $[12] = closeHandler;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default EmbedPostModal;